
//import { Balls } from './balls.js';
import {
    Urlparam
} from './urlparam.js'; // URLパラメータ

export class Opening {
    constructor() {
        this.body = {}
        this.html = {}
        this.env = {}
        this.paramAncher = {}
        this.flg = true;//loading表示

        this.loaderTimeBase = 0;
        this.loaderTime = 0;
        this.loadedFlg = false;
        this.timerLoadCheck = {}

        this.loaderTimeBase2 = 0;
        this.loaderTime2 = 0;
        this.loadedFlg2 = false;
        this.timerOpFinishedCheck = {}
    }


    loaded(){
        this.loadedFlg = true;
    }

    startLoader() {
        this.body = document.getElementsByTagName('body')[0];
        this.html = document.getElementsByTagName('html')[0];

        // 環境
        // this.env = new Env();
        // this.env.detectEnv();

        // URLパラメータ
        this.paramAncher = new Urlparam();
        this.paramAncher.getParam('loading', location.href);
        


        // Op判定
        if (document.getElementById('cover-opening')) {
            this.paramAncher.removeParams();
            //document.querySelector('.footer-common').classList.add('is-hide');

            if (this.paramAncher.param == 0) {
                this.flg = false;
            } else {
                this.flg = true;
            }
            
            if(this.flg){
                //loading表示
                document.getElementById('cover-opening').classList.add('show-loader');
                document.getElementById('cover-opening').classList.add('start-loader');
                window.setTimeout(() => { 
                    document.querySelector('.index-cover__loader').classList.add('motion-1');
                }, 50);
                window.setTimeout(() => { 
                    document.querySelector('.index-cover__loader').classList.add('motion-2');
                }, 600);
                window.setTimeout(() => { 
                    document.querySelector('.index-cover__loader').classList.add('motion-3');
                }, 1200);
            }else{

            }
            
            //console.log('show-loader');
            this.loaderTimeBase = new Date().getTime();
            this.timeCheckLoaded();
            
        }
    }

    timeCheckLoaded(){
        let minWaitTime = 0;
        if(this.flg){
            minWaitTime = 2000;
        }
        //loading完了かつn秒以上経過
        this.timerLoadCheck = setInterval(() => {
            this.loaderTime = new Date().getTime();
            let waitedTime = this.loaderTime - this.loaderTimeBase;
            //console.log('check: loadingWaitedTime=' + waitedTime);

            if (this.loadedFlg && waitedTime > minWaitTime) {
                clearTimeout(this.timerLoadCheck);
                document.getElementById('cover-opening').classList.add('end-loader');
                window.setTimeout(() => { 
                    document.getElementById('cover-opening').classList.remove('show-loader');
                    document.getElementById('cover-opening').classList.remove('start-loader');
                }, 1400);
               
                //console.log('startOp');
                window.setTimeout(() => { 
                    this.showMenu();
                }, 200);
                window.setTimeout(() => { 
                    this.startOpening();
                }, 600);
                // if(this.flg){
                // }else{
                    
                // }
            }
        }, 30);
    }

    timeCheckOpeningFinished(){
        this.loadedFlg2 = true;

        // concept bg balls
        //this.conceptCanvas = new Balls();
        

        //OP終了
        this.timerOpFinishedCheck = setInterval(() => {
            this.loaderTime2 = new Date().getTime();
            let waitedTime2 = this.loaderTime2 - this.loaderTimeBase2;
            if (this.loadedFlg2 && waitedTime2 > 2000) {
                clearTimeout(this.timerOpFinishedCheck);
                this.body.classList.add('opening-finished');
                //document.getElementById('cursor').classList.add('cursor--xl');
            }
        }, 30);
    }

    skipOpening(){
        //document.getElementById('cover-opening').classList.add('opening-finished');
        document.getElementById('cover-opening').classList.add('opening-skipped');
        if (document.getElementById('cover-opening')) {
            this.body.classList.add('cover-opening-show');
        }
    }

    showMenu(){
        document.getElementById('cursor').classList.add('cursor--xl');
        document.getElementById('side-ribbon').classList.add('is-show');
        this.body.classList.add('drawer-menu-show');
    }

    startOpening() {
        if (document.getElementById('cover-opening')) {
            this.body.classList.add('cover-opening-show');
        }

        this.loaderTimeBase2 = new Date().getTime();
        this.timeCheckOpeningFinished();
    }

    showMainContent() {
        let template;
        let clone;

        // -------------
        // HomeのOP以下のコンテンツ
        
        // templateで遅延する場合
        if (document.getElementById('js-index-content-container') && document.getElementById('index-content-template')) {
            template = document.getElementById('index-content-template');
            clone = template.content.cloneNode(true);
            document.getElementById('js-index-content-container').appendChild(clone);
            //document.getElementById('js-index-content-container').insertBefore(createElement, element);
            //document.querySelector('.footer-common').classList.remove('is-hide');
        }

        // displayで遅延する場合
        if(document.getElementById('js-index-content-container')) {
            document.getElementById('js-index-content-container').classList.add('is-show');
            //document.querySelector('.footer-common').classList.remove('is-hide');
        }

        // トップ footer
        if(document.getElementById('footer-common')) {
            document.getElementById('footer-common').classList.remove('is-hide');
        }
    }
    

    loadTypeSquare(){
        let template;
        let clone;
        template = document.getElementById('index-typesquare-template');
        clone = template.content.cloneNode(true);
        if (document.getElementById('js-index-typesquare-container') && document.getElementById('index-typesquare-template')) {
            document.getElementById('js-index-typesquare-container').appendChild(clone);
        }
    }

}